import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, postApi } from 'services/_api';
import { CHANNEL, PATH_PROCON } from 'services/_path';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { RespostaNaoResolvidaRequest, Types } from './types';

// ACTIONS
import {
	respostaNaoResolvidaSuccess,
	respostaNaoResolvidaFailure,
} from './actions';

function* respostaNaoResolvidaRequest(request: ReducerAction) {
	const { payload }: { payload: RespostaNaoResolvidaRequest } = request;

	const response: ApiResponse = yield call(
		postApi,
		PATH_PROCON,
		`atendimentos-cip/${CHANNEL}/cips/respostas-nao-resolvidas`,
		payload,
	);

	if (response.status === 200) {
		yield put(respostaNaoResolvidaSuccess(response));
	} else {
		yield put(respostaNaoResolvidaFailure(response));
	}
}

export default all([
	takeLatest(Types.RESPOSTA_NAO_RESOLVIDA_REQUEST, respostaNaoResolvidaRequest),
]);
